import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const Flota = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Flota/Flota.vue')

// Pages
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Requests from 'src/components/Dashboard/Views/Requests/Requests.vue'
import Contacts from 'src/components/Dashboard/Views/Contacts/Contacts.vue'
import Dashboard from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import ChargerReport from 'src/components/Dashboard/Views/ChargerReport/ChargerReport.vue'

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}
 

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dash',
        component: Dashboard
      },
      {
        path: 'fleet',
        name: 'Flota',
        component: Flota
      },
      {
        path: '/requests',
        name: 'Requests',
        component: Requests
      },
      {
        path: '/contacts',
        name: 'Contacts',
        component: Contacts
      },
      {
        path: '/charger-report',
        name: 'Punjači - izvještaj',
        component: ChargerReport
      },
    ]
  },

  loginPage,

  {path: '*', component: NotFound}
];

export default routes
